// -------------------------------------------------------------------------
// phiConfig — compile-time switch for PHI-related navigation & wording.
//
// show_phi = false  → 'Patients' nav hidden, 'Schedule' shown as 'Task Calendar',
//                     and 'HIPAA' / 'PHI' wording removed from public-facing
//                     headers, labels and badges.
// Flip to `true` to restore the original labels — no other code changes needed.
// (Runtime per-org PHI data masking is separate: see useShowPhi() in
//  hooks/useFeatureFlags.js.)
// -------------------------------------------------------------------------
export const show_phi = true;

/** Pick the PHI-aware label vs. the neutral label based on `show_phi`. */
export const phiText = (withPhi, neutral) => (show_phi ? withPhi : neutral);
